const contentfulTypes = [
  'addOn',
  'addOnCarousel',
  'addOnType',
  'dismissibleCard',
  'faq',
  'footer',
  'genericBanner',
  'homepageBanner',
  'pageSection',
  'plan',
  'planMapping',
  'planUpsell',
  'exitIntentOverlays',
  'plans',
  'roamingPageBanner',
  'thisPlanIncludesGroup',
  'page',
  'redirects',
]

const genericBannerNames = {
  TRY_OUR_APP: 'try-our-app',
  CHRISTMAS_OPENING_HOURS: 'christmas-opening-hours',
  PLAN_BENEFITS: 'plan-benefits-dashboard-fp-invitation',
  FP_PLAN_CARD: 'plan-card-dashboard-fp',
  FP_QUESTIONS: 'questions-dashboard-fp-invitation',
  FP_WHAT_YOU_CAN_DO: 'what-you-can-do-description-dashboard-fp-invitation',
  FP_THE_MEMBERS: 'the-members-dashboard-fp-invitation',
  FP_THE_OWNER: 'the-owner-dashboard-fp-invitation',
  FP_WELCOME_TO_GROUP: 'welcome-to-the-group-dashboard-fp',
  FP_WELCOME_TO_SMARTY: 'welcome-to-smarty-fp',
  FP_INVITE_REJECTED: 'invite-rejected-fp-dashboard',
  FP_SOLO_PLANS: 'we-also-have-solo-plans-fp-dashboard',
  INVITATION_SENT: 'invitation-sent-fp',
  INVITATION_RESEND: 'invitation-resend-fp',
  RAF_BANNER: 'refer-a-friend-personalised-banner',
  RAE_BANNER_BY_REFERRAL_LINK: 'refer-and-earn-banner-by-referral-link',
  RAE_BANNER_BY_BONUS_SIM: 'refer-and-earn-banner-by-bonus-sim',
  RAE_BANNER_SEND_BY_POST: 'refer-and-earn-send-sim-by-post',
  RAE_BANNER_A_FREE_SIM_BY_POST: 'refer-and-earn-order-a-free-sim-by-post',
  INVALID_INVITATION_IN_GROUP: 'invalid-invitation-already-in-group',
  INVALID_INVITATION_NOT_IN_GROUP: 'invalid-invitation-not-in-group',
  SWITCH_TO_SMARTY: 'switch-to-smarty',
  EVERYONE_UNLIMITED: 'everyone-unlimited',
  ACTIVATE_YOUR_SIM_FIRST: 'you-need-to-activate-your-sim-first',
  FP_REQUEST_ACTIVATION: 'request-activation-when-you-receive-your-sim-fp',
  FP_ACTIVATION_FAILED: 'activation-failed-fp',
  FP_ACTIVATE_NOW_OWNER: 'activate-now-owner-fp',
  FP_ACTIVATE_NOW_OWNER_AS_MEMBER: 'activate-now-owner-as-member-fp',
  FP_ACTIVATE_NOW_MEMBER: 'activate-now-member-fp',
  FP_ACTIVATION_IN_PROGRESS: 'activation-in-progress-fp',
  SWITCHING_YOUR_SERVICES_WARNING: 'switching-your-services-warning-fp',
  FP_WHAT_IS_STAC: 'what-is-a-stac-code-fp',
  FP_WHAT_IS_PAC: 'what-is-a-pac-code-fp',
  GOT_YOUR_DETAILS_WHAT_NEXT: 'whats-next-fp',
  FP_INVALID_ACCOUNT: 'invalid-account-fp',
  FP_MEMBER_INVITATION_SENT: 'member-invitation-sent-fp',
  FP_MEMBER_INVITATION_ACCEPTED: 'invitation-accepted-fp', //TODO: do we need to remove this banner from contentful completely ?
  FP_REJECT_INVITE: 'reject-invitation-fp',
  FP_ACTIVATION_PENDING: 'activation-pending-fp',
  FP_OWNER_ACTIVATE_SIM: 'activate-own-sim-fp',
  AWAITING_OWNER_ACTIVATION: 'awaiting-owner-activation-fp',
  FP_MEMBER_ACTIVATE_SIM: 'activate-their-sim-fp',
  FP_DEVICE_ACTIVATE_SIM: 'activate-device-sim-fp',
  FP_AWAITING_ACTIVATION: 'awaiting-activation-fp',
  FP_PLAN_CHANGE_PENDING: 'plan-change-pending-fp',
  FP_ACTIVATION_FAILED_MEMBER: 'something-went-wrong-fp-member',
  FP_MEMBER_AWAITING_ACTIVATION: 'awaiting-activation-member-fp',
  FP_PLEASE_LOGOUT: 'please-log-out-fp',
  FP_PORTIN_POOL_WARNING: 'portin-pool-warning-fp',
  FP_PAUSED_MEMBER_PLAN: 'paused-member-plan-fp',
  FP_EXPIRED_MEMBER_PLAN: 'expired-member-plan-fp',
  FP_PENDING_INVITATION: 'pending-invitation-fp',
  FP_RESUME_YOUR_PLAN_FIRST: 'resume-your-plan-first-fp',
  FP_RESTART_YOUR_PLAN_FIRST: 'restart-your-plan-first-fp',
  FP_SOLO_PLAN_CHANGE_FAILURE: 'solo-plan-change-failure-fp',
  REPLACEMENT_SIM: 'replacement-sims',
  REPLACEMENT_SIM_LIMIT: 'replacement-sims-limit',
  DELIVERY_ADDRESSES_LIMIT: 'delivery-addresses-limit',
  ACTIVATE_SIM_FIRST: 'activate-your-sim-first',
  SIM_ACTIVATION_IN_PROGRESS: 'sim-activation-in-progress',
  REMOVE_MEMBER: 'remove-member',
  MEMBER_REMOVED: 'member-removed',
  REMOVE_MEMBER_MODAL: 'remove-member-modal',
  ROAMING_3G_MESSAGE: 'roaming-and-international-3g-message',
  TRAVELLING_OUTSIDE_THE_EU: 'travelling-outside-the-eu',
  TRAVELLING_IN_THE_EU: 'travelling-in-the-eu',
  JUST_CLOSE_MY_ACCOUNT: 'just-close-my-account',
  GO_CLOSE_OVER16_ACCOUNT: 'go-close-over16-account',
  CLOSE_ACCOUNT_REQUEST_PAC_STAC: 'close-account-request-pac-stac',
  LEAVING_GROUP: 'leaving-group',
  ACTIVE_MEMBERS_IN_YOUR_PLAN: 'has-active-members-in-your-plan',
  ARE_YOU_SURE_YOU_WANT_TO_LEAVE_SMARTY:
    'are-you-sure-you-want-to-leave-smarty',
  CONFIRMATION_EMAIL_HAS_BEEN_SENT: 'confirmation-email-has-been-sent',
  MEMBER_CLOSE_CONFIRMATION_EMAIL_HAS_BEEN_SENT:
    'member-close-confirmation-email-has-been-sent',
  CONFIRM_ACCOUNT_CLOSURE: 'confirm-account-closure',
  PAYMENT_AUTO_RENEW_ON_MODAL: 'payment-auto-renew-on-modal',
  PAYMENT_AUTO_RENEW_SETTINGS_HAVE_BEEN_UPDATED:
    'your-auto-renew-settings-have-been-updated',
  NUMBER_SWITCH_IN_PROGRESS_MODAL: 'number-switch-in-progress',
  FP_COMPLAINT_SUCCESS_MODAL: 'complaint-success-modal-fp',
  FP_NOT_IN_GROUP_MODAL: 'you-are-no-longer-part-of-the-group-fp',
  SMARTY_PRODUCT_SIM: 'smarty-product-sim',
}

const planCollectionNames = {
  SOCIAL_PLANS: 'social_tariff_plans',
  VOICE_PLANS: 'voice_plans',
  MONEY_BACK_PLANS: 'money_back_plans',
  DATA_ONLY_PLANS: 'data_only_plans',
  UNSUPPORTED_PLANS: 'unsupported_plans',
  UNLIMITED_PLANS: 'unlimited_plans',
  CURRENT_OFFERS_PLANS: 'current_offers_plans',
  FAMILY_PLANS: 'family',
  RETAIL_PLANS: 'retail',
}

module.exports = {
  contentfulTypes,
  genericBannerNames,
  planCollectionNames,
}
